import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import animated from "animate.css";
import "./assets/css/index.css";
import "./assets/css/iconfont.css";
import "./assets/css/markdown.css";
import "./assets/css/theme.css";
import "./assets/css/dark.css";
import { initTheme } from "./assets/js/theme";
// mdi 字体走 jsdelivr 时国内下载要十几秒甚至超时，改成本地打包
import "@mdi/font/css/materialdesignicons.css";
import "./assets/css/vue-social-share/client.css";
import config from "./assets/js/config";
import Share from "vue-social-share";
import dayjs from "dayjs";
import { vueBaberrage } from "vue-baberrage";
import axios from "axios";
import VueAxios from "vue-axios";
import InfiniteLoading from "vue-infinite-loading";
import "highlight.js/styles/atom-one-dark.css";
import VueImageSwipe from "vue-image-swipe";
import "vue-image-swipe/dist/vue-image-swipe.css";
import Toast from "./components/toast/index";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import MetaInfo from 'vue-meta-info'
import { initSiteAnalytics } from "./utils/site-analytics";
Vue.use(MetaInfo)
initTheme();
Vue.prototype.config = config;
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(animated);
Vue.use(Share);
Vue.use(vueBaberrage);
Vue.use(InfiniteLoading);
Vue.use(VueAxios, axios);
Vue.use(VueImageSwipe);
Vue.use(Toast);

Vue.filter("date", function(value) {
  return dayjs(value).format("YYYY-MM-DD");
});

Vue.filter("year", function(value) {
  return dayjs(value).format("YYYY");
});

Vue.filter("hour", function(value) {
  return dayjs(value).format("HH:mm:ss");
});

Vue.filter("num", function(value) {
  if (value >= 1000) {
    return (value / 1000).toFixed(1) + "k";
  }
  return value;
});

router.beforeEach((to, from, next) => {
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(['_trackPageview',to.fullPath]);
    }
  }
  NProgress.start();
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // 没配 metaInfo 的页面（留言等）在这里兜底描述和 canonical，
  // 配了 metaInfo 的页面挂载后会自己覆盖掉
  setMeta("description", to.meta.description);
  setCanonical(to.path);
  next();
});

function setMeta(name, content) {
  if (!content) return;
  var el = document.querySelector('meta[name="' + name + '"]');
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// vue-meta-info 是往 head 里追加标签，不会替换 index.html 里的静态同名标签，
// 结果每个页面都有两份 description / og:*，爬虫读到的是靠前那份站点默认值。
// 这里盯住 head 的变化，受控的几个标签同名只保留最后写入的一份。
var DEDUPE_KEYS = [
  "name:description",
  "name:keywords",
  "prop:og:type",
  "prop:og:title",
  "prop:og:description",
  "prop:og:url",
  "prop:og:image",
  "name:twitter:card",
  "link:canonical"
];

var deduping = false;

function tagKey(el) {
  if (el.tagName === "LINK") return "link:canonical";
  var n = el.getAttribute("name");
  if (n) return "name:" + n;
  var pr = el.getAttribute("property");
  return pr ? "prop:" + pr : null;
}

function dedupeHeadTags() {
  if (deduping) return;
  deduping = true;
  var nodes = document.head.querySelectorAll(
    'meta[name], meta[property], link[rel="canonical"]'
  );
  var groups = {};
  Array.prototype.forEach.call(nodes, function(el) {
    var k = tagKey(el);
    if (!k || DEDUPE_KEYS.indexOf(k) === -1) return;
    (groups[k] = groups[k] || []).push(el);
  });
  Object.keys(groups).forEach(function(k) {
    var list = groups[k];
    // 保留最后一个（组件 metaInfo 写入的那份），前面的删掉
    for (var i = 0; i < list.length - 1; i++) {
      if (list[i].parentNode) list[i].parentNode.removeChild(list[i]);
    }
  });
  deduping = false;
}

if (typeof MutationObserver !== "undefined") {
  var headTimer = null;
  new MutationObserver(function() {
    if (deduping) return;
    clearTimeout(headTimer);
    headTimer = setTimeout(dedupeHeadTags, 60);
  }).observe(document.head, { childList: true, subtree: false });
}

function setCanonical(path) {
  var href = "https://www.88688.team" + (path === "/" ? "/" : path);
  var el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

router.afterEach(() => {
  window.scrollTo({
    top: 0,
    behavior: "instant"
  });
  NProgress.done();
});

axios.interceptors.response.use(
  function(response) {
    switch (response.data.code) {
      case 50000:
        Vue.prototype.$toast({ type: "error", message: "系统异常" });
    }
    return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);

initSiteAnalytics(router);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
